import { gql } from '@apollo/client';

export const GET_MEMORY_STATS = gql(/* GraphQL */ `
    query GetMemoryStats {
        getMemoryStats {
            totalProcessMemoryMb
            javascriptHeapUsedMb
            javascriptHeapTotalMb
            nativeMemoryMb
            externalMemoryMb
            arrayBuffersMb
            heapSizeLimitMb
            availableHeapMb
            uptimeSeconds
            containerLimitMb
        }
    }
`);
